(() => {
  const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  function prepare(event) {
    if (!supportsHover.matches || !(event.target instanceof Element)) return;
    const card = event.target.closest('[data-ns-product-hover]');
    const image = card?.querySelector('[data-ns-hover-image]');
    if (!image || image.dataset.nsRequested) return;
    image.dataset.nsRequested = 'true';
    image.addEventListener('load', async () => {
      try { if (image.decode) await image.decode(); } catch (_) { return; }
      if (image.naturalWidth) image.closest('.ns-product-hover__media').classList.add('ns-hover-ready');
    }, {once:true});
    image.addEventListener('error', () => image.remove(), {once:true});
    image.srcset = image.dataset.nsSrcset;
    image.src = image.dataset.src;
  }
  document.addEventListener('pointerover', prepare, true);
  document.addEventListener('focusin', prepare, true);
})();
